module.exports = __webpack_public_path__ + "img/2.3-Pivot-Count-Added.1ca35818.png";